import { ChangeDetectionStrategy, Component, Resource, signal } from '@angular/core';
import { ResourceContainerComponent } from '@softapps/core';
import { ILoadingOverlayParams } from 'ag-grid-enterprise';

@Component({
  selector: 'soft-grid-no-rows',
  imports: [
    ResourceContainerComponent
  ],
  template: `
    @if (resource(); as res) {
      <soft-resource-container [resource]="res"></soft-resource-container>
    }`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridNoRowsOverlay {
  resource = signal<Resource<any> | undefined>(undefined);

  agInit(params: ILoadingOverlayParams<any, any> & {dataSource?: Resource<any>}): void {
    this.resource.set(params.dataSource);
  }
  refresh?(params: ILoadingOverlayParams<any, any> & {dataSource?: Resource<any>}): void {
    this.resource.set(params.dataSource);
  }
}
